import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { parseDataJogo, toDatetimeLocalValue } from '../../utils/dataJogo';

const fmt = toDatetimeLocalValue;

export default function AdminJogos() {
  const [jogos, setJogos] = useState([]);
  const [campeonatos, setCampeonatos] = useState([]);
  const [campSel, setCampSel] = useState('');
  const [rodadas, setRodadas] = useState([]);
  const [times, setTimes] = useState([]);
  const [form, setForm] = useState({ rodada_id: '', time_casa_id: '', time_fora_id: '', data_jogo: '' });
  const [editando, setEditando] = useState(null);
  const [finalizarModal, setFinalizarModal] = useState(null);
  const [gols, setGols] = useState({ gols_casa: 0, gols_fora: 0 });
  const [msg, setMsg] = useState('');

  useEffect(() => { api.get('/campeonatos').then(setCampeonatos).catch(() => {}); }, []);

  useEffect(() => {
    if (!campSel) { setJogos([]); setRodadas([]); setTimes([]); return; }
    api.get(`/jogos?campeonato_id=${campSel}`).then(setJogos).catch(() => {});
    api.get(`/rodadas/campeonato/${campSel}`).then(setRodadas).catch(() => {});
    api.get(`/times/campeonato/${campSel}`).then(setTimes).catch(() => {});
  }, [campSel]);

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const payload = { ...form, campeonato_id: campSel };
      if (editando) { await api.put(`/jogos/${editando.id}`, { ...payload, gols_casa: editando.gols_casa, gols_fora: editando.gols_fora, finalizado: editando.finalizado }); }
      else { await api.post('/jogos', payload); }
      setMsg('Salvo!'); resetForm();
      api.get(`/jogos?campeonato_id=${campSel}`).then(setJogos);
    } catch (err) { setMsg(err.message); }
  }

  function resetForm() {
    setForm({ rodada_id: '', time_casa_id: '', time_fora_id: '', data_jogo: '' });
    setEditando(null);
  }

  async function finalizar(e) {
    e.preventDefault(); setMsg('');
    try {
      await api.patch(`/jogos/${finalizarModal.id}/finalizar`, { gols_casa: Number(gols.gols_casa), gols_fora: Number(gols.gols_fora) });
      setMsg('Jogo finalizado e pontos distribuídos!'); setFinalizarModal(null);
      api.get(`/jogos?campeonato_id=${campSel}`).then(setJogos);
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover?')) return;
    await api.delete(`/jogos/${id}`);
    api.get(`/jogos?campeonato_id=${campSel}`).then(setJogos);
  }

  return (
    <div>
      <h2 className="admin-title">Jogos</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="form-group">
        <label>Campeonato</label>
        <select value={campSel} onChange={e => setCampSel(e.target.value)}>
          <option value="">Selecione</option>
          {campeonatos.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      {finalizarModal && (
        <form onSubmit={finalizar} className="admin-form">
          <h3>Finalizar: {finalizarModal.time_casa_nome} x {finalizarModal.time_fora_nome}</h3>
          <div className="form-row">
            <div className="form-group"><label>Gols {finalizarModal.time_casa_nome}</label><input type="number" min={0} value={gols.gols_casa} onChange={e => setGols({ ...gols, gols_casa: e.target.value })} required /></div>
            <div className="form-group"><label>Gols {finalizarModal.time_fora_nome}</label><input type="number" min={0} value={gols.gols_fora} onChange={e => setGols({ ...gols, gols_fora: e.target.value })} required /></div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-success">Finalizar e Pontuar</button>
            <button type="button" className="btn btn-secondary" onClick={() => setFinalizarModal(null)}>Cancelar</button>
          </div>
        </form>
      )}

      {campSel && !finalizarModal && (
        <form onSubmit={salvar} className="admin-form">
          <h3>{editando ? 'Editar Jogo' : 'Novo Jogo'}</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Rodada</label>
              <select value={form.rodada_id} onChange={e => setForm({ ...form, rodada_id: e.target.value })} required>
                <option value="">Selecione</option>
                {rodadas.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Data e Hora</label><input type="datetime-local" value={form.data_jogo} onChange={e => setForm({ ...form, data_jogo: e.target.value })} required /></div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Time Casa</label>
              <select value={form.time_casa_id} onChange={e => setForm({ ...form, time_casa_id: e.target.value })} required>
                <option value="">Selecione</option>
                {times.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Time Fora</label>
              <select value={form.time_fora_id} onChange={e => setForm({ ...form, time_fora_id: e.target.value })} required>
                <option value="">Selecione</option>
                {times.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
              </select>
            </div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Salvar</button>
            {editando && <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancelar</button>}
          </div>
        </form>
      )}

      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Data</th><th>Casa</th><th>Placar</th><th>Fora</th><th>Rodada</th><th>Status</th><th>Ações</th></tr></thead>
          <tbody>
            {jogos.map(j => (
              <tr key={j.id}>
                <td style={{ fontSize: 12 }}>{parseDataJogo(j.data_jogo).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</td>
                <td>{j.time_casa_nome}</td>
                <td style={{ fontWeight: 700 }}>{j.finalizado ? `${j.gols_casa} x ${j.gols_fora}` : 'vs'}</td>
                <td>{j.time_fora_nome}</td>
                <td>{j.rodada_nome}</td>
                <td>{j.finalizado ? <span className="badge badge-success">Finalizado</span> : <span className="badge badge-info">Aberto</span>}</td>
                <td>
                  <div className="admin-actions">
                    {!j.finalizado && <button className="btn btn-success" onClick={() => { setFinalizarModal(j); setGols({ gols_casa: 0, gols_fora: 0 }); }}>Finalizar</button>}
                    <button className="btn btn-secondary" onClick={() => { setEditando(j); setForm({ rodada_id: j.rodada_id, time_casa_id: j.time_casa_id, time_fora_id: j.time_fora_id, data_jogo: fmt(j.data_jogo) }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(j.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
